'use client'

import { formatDate } from '@shared/lib/utils'

/** Client component so that the date is always up-to-date and not cached */
export function CurrentDate() {
  return formatDate()
}
